import { create } from 'zustand';

/** Replaces `NotificationsService` - the toolbar's notification tray. */

export interface AppNotification {
  id: string;
  headline: string;
  detail: string;
  read?: boolean;
}

export interface NotificationsState {
  notifications: AppNotification[];
  markAllRead: () => void;
  dismiss: (id: string) => void;
  clearAll: () => void;
}

export const useNotificationsStore = create<NotificationsState>((set, get) => ({
  // Empty until a real notifications feed exists.
  notifications: [],

  markAllRead: () => {
    // Guarded so opening an already-read tray does not churn the store and
    // re-render the toolbar for nothing.
    if (!get().notifications.some((notification) => !notification.read)) {
      return;
    }

    set((state) => ({
      notifications: state.notifications.map((notification) => ({ ...notification, read: true }))
    }));
  },

  dismiss: (id) =>
    set((state) => ({
      notifications: state.notifications.filter((notification) => notification.id !== id)
    })),

  clearAll: () => set({ notifications: [] })
}));

/** Unread count, derived rather than stored so it cannot drift. */
export function useUnreadCount(): number {
  return useNotificationsStore(
    (state) => state.notifications.filter((notification) => !notification.read).length
  );
}
